import { Factory } from "@/data/dao/Factory";
import { PlanningDao } from "@/data/dao/service/PlanningDao";
import type { IPayApplicationWithPaymentMethods } from "@/data/model/PayApplication";
import { Format } from "@/data/util/Format";



import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { PayApplicationForm } from "@/portal/forms/PayApplicationForm";
import { TastierGlobal } from "@/portal/globalAccess";


export class PayApplicationController extends BaseTabbedController<IPayApplicationWithPaymentMethods> {
    private payApplicationForm: PayApplicationForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<PlanningDao>(PlanningDao).payUseCaseDataSource as any);

        this.payApplicationForm = new PayApplicationForm(this.formContentByTabName("payapplicationedit"));
        this.registerModelForm(this.payApplicationForm);
    }

    protected onModelLoaded(m?: IPayApplicationWithPaymentMethods) {
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        }

        this.payApplicationForm.setData(m);
    }
}
